import { Link } from "react-router-dom";
import { Mail, Phone, Globe, MapPin, ExternalLink } from "lucide-react";
import { LOGO, CONTACT, EVENT, FOUNDATION_URL, FOUNDATION_DOMAIN } from "@/data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-espresso text-cream mt-auto">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <img src={LOGO} alt="The Wayne Walker Heroes & Legacy Golf Classic" className="h-28 w-28 object-contain" />
          <p className="mt-4 text-sm text-cream/70 leading-relaxed">
            The Wayne Walker Heroes & Legacy Golf Classic — a day of golf benefiting the {EVENT.beneficiary}.
          </p>
          <a
            href={FOUNDATION_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-foundation-site-link"
            className="mt-4 inline-flex items-center gap-1.5 text-xs label-font text-rust hover:text-cream transition-colors"
          >
            {FOUNDATION_DOMAIN} <ExternalLink size={12} />
          </a>
        </div>

        <div>
          <h4 className="label-font text-xs text-rust mb-4">Explore</h4>
          <ul className="space-y-2 text-sm text-cream/80">
            <li><Link to="/about" className="hover:text-rust transition-colors">The Foundation</Link></li>
            <li><a href={FOUNDATION_URL} target="_blank" rel="noopener noreferrer" className="hover:text-rust transition-colors inline-flex items-center gap-1.5">Foundation Website <ExternalLink size={11} /></a></li>
            <li><Link to="/cause" className="hover:text-rust transition-colors">The Cause</Link></li>
            <li><Link to="/event" className="hover:text-rust transition-colors">Event Details</Link></li>
            <li><Link to="/sponsor" className="hover:text-rust transition-colors">Become a Sponsor</Link></li>
            <li><Link to="/register" className="hover:text-rust transition-colors">Register a Team</Link></li>
            <li><Link to="/donate" className="hover:text-rust transition-colors">Donate</Link></li>
            <li><a href="/flyer" target="_blank" rel="noreferrer" className="hover:text-rust transition-colors">Event Flyer (PDF)</a></li>
          </ul>
        </div>

        <div>
          <h4 className="label-font text-xs text-rust mb-4">Get In Touch</h4>
          <ul className="space-y-3 text-sm text-cream/80">
            <li className="flex items-center gap-2"><Mail size={15} className="text-rust" /> {CONTACT.sponsorEmail}</li>
            <li className="flex items-center gap-2"><Phone size={15} className="text-rust" /> {CONTACT.sponsorPhone}</li>
            <li className="flex items-center gap-2"><Globe size={15} className="text-rust" /> {CONTACT.website}</li>
          </ul>
        </div>

        <div>
          <h4 className="label-font text-xs text-rust mb-4">The Event</h4>
          <ul className="space-y-3 text-sm text-cream/80">
            <li className="flex items-start gap-2"><MapPin size={15} className="text-rust mt-0.5 shrink-0" /> <span>{EVENT.venue} — {EVENT.venueCourse}<br />{EVENT.address}</span></li>
            <li>{EVENT.dateLabel}</li>
            <li>{EVENT.dayLabel}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-cream/15">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
          <span>© {new Date().getFullYear()} The Wayne Walker Heroes & Legacy Golf Classic · Est. 2027 · Montgomery County, Texas</span>
          <Link to="/admin" className="hover:text-rust transition-colors label-font tracking-widest">Organizer Login</Link>
        </div>
      </div>
    </footer>
  );
}
